import apiService from "./BaseApi";
const ENDPOINT = "diagnostic";
import store from '@/store/index'
const DiagnosticService = {
    findById: async (idDiagnostic) => apiService.get(ENDPOINT + `/${idDiagnostic}`, { currentUserId: store.state.currentUser?.uid }),
    create: async (diagnostic) => apiService.post(ENDPOINT, { ...diagnostic, currentUserId: store.state.currentUser?.uid }),
    update: async (diagnostic) => apiService.put(ENDPOINT, { ...diagnostic, currentUserId: store.state.currentUser?.uid }),
};

export default DiagnosticService;
